import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { stringify } from "query-string";
import { urlReplacer } from "../../../utils";
import {
  IGetPrivateClassBackEndModel,
  IPrivateClassListItemBackEndModel,
  IPrivateClassSubject,
  IViewMorePrivateClassBackEndModel,
} from "../types";

export default function () {
  const { request } = useApi();

  return {
    getPrivateClassSubjectList: useCallback(async (): Promise<{
      data: IPrivateClassSubject[];
    }> => {
      return request({
        method: "GET",
        url: `${ApiRoutes.PRIVATE_CLASS_CONTROLLER}/subject`,
      });
    }, [request]),
    getPrivateClassList: useCallback(
      async (
        filter,
      ): Promise<{ data: IPrivateClassListItemBackEndModel[] }> => {
        return request({
          method: "GET",
          url:
            ApiRoutes.GET_PRIVATE_CLASSES_FOR_TEACHER + "?" + stringify(filter),
        });
      },
      [request],
    ),

    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.PRIVATE_CLASS_CONTROLLER,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.PRIVATE_CLASS_CONTROLLER,
        });
      },
      [request],
    ),

    uploadDetailFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_SERVICE_DETAIL_FILE}`,
          data: formData,
        });
      },
      [request],
    ),

    uploadExtraFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_PRIVATE_CLASS_EXTRA_FILE}`,
          data: formData,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id): Promise<{ data: IGetPrivateClassBackEndModel }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.ONE_PRIVATE_CLASS, { id })}`,
        });
      },
      [request],
    ),

    fetchViewMore: useCallback(
      async (id): Promise<{ data: IViewMorePrivateClassBackEndModel }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_VIEW_MORE_PRIVATE_CLASS, { id })}`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.ONE_PRIVATE_CLASS, { id })}`,
        });
      },
      [request],
    ),
  };
}
